import React from 'react';
import { Container } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation } from 'swiper/modules';
import Products from './Products';
import Loader from './Loader';

import 'swiper/css';
import 'swiper/css/navigation';

const CollectionCarousel = ({ title, viewAllLink, products, isLoading }) => {
    if (isLoading) return <Loader />;
    const validProducts = (products || []).filter(p => !isNaN(Number(p.price)) && p.price != null);
    if (validProducts.length === 0) return null;

    return (
        <section className="rd-section rd-carousel">
            <Container>
                <div className="rd-section-head">
                    <h2>{title}</h2>
                    {viewAllLink && <Link to={viewAllLink}>View all &rarr;</Link>}
                </div>

                <Swiper
                    modules={[Navigation]}
                    spaceBetween={12}
                    slidesPerView={2.2}
                    navigation
                    breakpoints={{
                        768: { slidesPerView: 3, spaceBetween: 20 },
                        992: { slidesPerView: 4, spaceBetween: 20 },
                        1200: { slidesPerView: 5, spaceBetween: 20 },
                    }}
                >
                    {validProducts.map((product) => (
                        <SwiperSlide key={product._id}>
                            <Products product={product} showDiscount={product.isClearance} hideEmptyRating />
                        </SwiperSlide>
                    ))}
                </Swiper>
            </Container>
        </section>
    );
};

export default CollectionCarousel;
